export const MASTER_NUMBER_DATA = 'MASTER_NUMBER_DATA';
export const ADD_AMOUNT = 'ADD_AMOUNT';
export const DELETE_MASTER_NUMBER_DATA = 'DELETE_MASTER_NUMBER_DATA,';
